import React, { createContext, useContext, useEffect, ReactNode } from 'react';
import { useLicense } from './useLicense';

// Create context with default values
const LicenseContext = createContext<ReturnType<typeof useLicense> | null>(null);

// Provider component
export function LicenseProvider({ children }: { children: ReactNode }) {
  const licenseState = useLicense();
  const { initFromStorage, claimFromUrl } = licenseState;
  
  // Initialize license on mount
  useEffect(() => {
    initFromStorage();
  }, [initFromStorage]);
  
  // Check URL for auto-claim on mount
  useEffect(() => {
    claimFromUrl();
  }, [claimFromUrl]);
  
  return (
    <LicenseContext.Provider value={licenseState}>
      {children}
    </LicenseContext.Provider>
  );
}

// Hook for components to use
export function useLicenseContext() {
  const context = useContext(LicenseContext);
  if (!context) {
    throw new Error('useLicenseContext must be used within a LicenseProvider');
  }
  return context;
}
